import React, {useState} from "react";
import {useMutation} from "react-query";
import {createTeacherPlayList} from "../../api/playlist";
import {useHistory, useLocation, useParams, useRouteMatch} from "react-router-dom";
import {FiSearch} from "react-icons/fi";
import {BiPlus} from "react-icons/bi";
import BlockCustomDialog from "./BlockCustomDialog";
import moment from "moment";
import {useKeycloak} from "@react-keycloak/web";


export default function BlockAddQuestion() {
    const history = useHistory();
    const {url} = useRouteMatch()
    const {keycloak} = useKeycloak();

    const param = useParams();
    const classId = param.classId;
    const location = useLocation();
    const playlistId = location?.state?.id;
    const playlistTitle = "Question list 1";

    const [searching, setSearching] = useState(false);
    const [isOpen, setOpen] = useState(false);
    const [playListTitle, _playListTitle] = useState('');
    const splitData = url.split('/')
    const newUrl = splitData.slice(0, 4).join('/');

    // useEffect(() => {
    //     if (!playlistId && !playlistTitle) {
    //         history.push(newUrl)
    //     }
    // }, [location]);
    //use to create teacher playList
    const {
        isLoading: isCreating,
        error: createError,
        isError: isCreateError,
        mutate,
        data
    } = useMutation(createTeacherPlayList, {
        onSuccess: (data, variables) => {
            if (data?.status === 201) {
                const playlistData = data.data.body;
                const id = playlistData.id;
                const title = playlistData.title;
                history.push({
                    pathname: `${url}/playlist`,
                    state: {
                        id: id,
                        title: title
                    }
                });
                setOpen(false);
            }
        },
        onError: (err) => {
            console.log(err);
        },
    });

    const handleCreatePlaylist = () => {
        insertPayList();
    }

    let insertPayList = () => {
        const start_time = moment().unix();
        const payload = {
            "id": classId,
            "title": playListTitle,
            "description": "string",
            "teacher_id": keycloak?.idTokenParsed?.sid,
            "createdOn": start_time,
            "modifiedOn": 0,
            "content": []
        }

        mutate(payload);
    }

    const redirectToAddBooleanQuestion = () => {
        history.push(`${newUrl}/add-boolean-question/1`);
    }

    return (<>
        <div className="flex item-center border-b border-b-black gap-x-2">
            {searching ? (
                <input
                    type="text"
                    className="bg-transparent w-full px-4 outline-0"
                    placeholder="Search"
                />
            ) : (
                <h4 className="text-xl flex-auto">Search</h4>
            )}
            <FiSearch
                size={20}
                className="cursor-pointer"
                onClick={() => setSearching(true)}
            />
            <BiPlus
                size={20}
                className="cursor-pointer"
                onClick={() => setOpen(true)}
            />
        </div>
        <div className="flex-auto flex-col flex">
            <h4 className="text-xl my-3">{playlistTitle}</h4>
            <div className="flex flex-col flex-auto items-center justify-center h-full w-full gap-3">
                <p>Find some content for your playlist</p>
                <button
                    onClick={() => redirectToAddBooleanQuestion()}
                    className="w-60 mx-auto px-10 py-2 text-white bg-black font-extrabold font-[Poppins-Bold] rounded-lg">
                    Add content
                </button>
            </div>
        </div>
        <BlockCustomDialog
            targetId="contentWrapperBox"
            open={isOpen}
            onClose={() => setOpen(false)}
            overlayClasses="justify-center items-center backdrop-blur-md"
        >
            <div className="w-96 flex flex-col rounded-full p-4">
                <h4 className="text-lg text-center font-medium">
                    Start adding questions to this set
                </h4>
                <div className="mb-6">
                    <input
                        type="text"
                        placeholder="Give your set a name"
                        className="text-center w-full bg-neutral-100 py-4 px-2 my-2"
                        onChange={(e) => _playListTitle(e.target.value)}
                    />
                </div>
                <button
                    onClick={handleCreatePlaylist}
                    className="w-40 mx-auto px-10 py-2 text-white bg-black font-extrabold font-[Poppins-Bold] rounded-lg">
                    Create
                </button>
            </div>
        </BlockCustomDialog>
    </>)
}
